seedWebApp.controller('DocTypesController', ['$scope', '$rootScope', '$uibModal', 'ToastService', 'TranslationService', 'DocService',
    function ($scope, $rootScope, $uibModal, ToastService, TranslationService, DocService) {
        console.log('docTypesController');

        $scope.translation = TranslationService.getActiveTranslation();
        $scope.prefs = {
            name: 'DocTypesGrid',
            sortByCol: null,
            canAdd: true,
            canEdit: true,
            canDelete: false,
        };

        $scope.idClass = function (item) {
            return 'agp-color';
        };

        $scope.seqClass = function (item) {
            return 'sd-border-label';
        };

        $scope.columns = [
            { name: 'DocTypeID', display: 'ID', orderBy: 'asc', editable: false, width: 10, isKey: true, customClass: $scope.idClass },  //filterOptions: [] 
            { name: 'DocTypeName', display: 'Nome', editable: true, width: 15 },
            { name: 'DocTypeShort', display: 'Abrev', editable: true, width: 5 },
            { name: 'IsAutomatic', display: 'Automático', filterOptions: [], editable: true, width: 15, dataType: 'boolean' },
        ];

        $scope.prefs.sortByCol = $scope.columns[0];
        $scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = DocService.getDocTypes;
        $scope.resetService = DocService.resetCache;
        //$scope.loadColumns = ContactService.getContactsColumns;

        /*
        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            StoreService.getStatusCount().then(function (response) {
                $scope.loadingTotal = false;
                if (response) {
                    $scope.totalItems = response.data.TotalCount;
                    $scope.lastSync = response.data.LastSync;
                }

            });
        };
        $scope.getTotal();
        */

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'docTypes');
        };

        $scope.prefs.customEdit = function (item) {
            docTypeModalResult(openModalDocType(item));
        };

        $scope.doInsert = function () {
            docTypeModalResult(openModalDocType());
        };

        function openModalDocType(item) {
            return $uibModal.open({
                templateUrl: './SPA/Settings/Docs/docTypeModal.html' + seedWebApp.buildVersion,
                controller: 'DocTypeModalCtrl as ctrl',
                size: 'md',
                resolve: {
                    item: function () {
                        return item ? item : {};
                    },
                    translation: function () {
                        return $scope.translation;
                    },
                    isEdit: function () {
                        return item ? true : false;
                    }
                }
            });
        }

        function docTypeModalResult(modalInstance) {
            modalInstance.result.then(function () {
                $scope.doRefresh();
            });
        }
    }
]);

